import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, TruckIcon, ClockIcon, ShieldCheckIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function FleetServicesPage() {
  const [form, setForm] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    fleet: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const inputClass = 'w-full px-4 py-3.5 border border-gray-200 bg-white text-black text-sm placeholder-gray-400 focus:outline-none focus:border-[#822433] transition-colors';
  return <div data-id="element-748">
      {/* Hero Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" style={{
      background: '#000000'
    }} data-id="element-749">
        <img src="https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-750" />
        <div className="relative z-10" data-id="element-751">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-752">
            Work With Us
          </p>
          <h1 className="text-4xl sm:text-6xl font-black text-white mb-4" data-id="element-753">
            Fleet Services
          </h1>
          <div className="w-12 h-0.5 mx-auto mb-6" style={{
          background: '#FECB00'
        }} data-id="element-754" />
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-755">
            Reliable, scheduled tire maintenance for your entire fleet. Keep
            your vehicles on the road and your business moving.
          </p>
        </div>
      </div>

      {/* Intro 2-col */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-756">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-757">
          <div data-id="element-758">
            <p className="text-xs font-bold uppercase mb-4" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-759">
              Why Ameritech Fleet
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-6" data-id="element-760">
              Keep Your Entire Fleet Road-Ready
            </h2>
            <div className="w-10 h-0.5 mb-6" style={{
            background: '#FECB00'
          }} data-id="element-761" />
            <p className="text-base leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-762">
              Ameritech Tires has been the DMV's trusted tire partner for over
              30 years. Our fleet services program is designed for businesses
              that depend on their vehicles — from delivery vans and company
              cars to large commercial trucks.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{
            color: '#616365'
          }} data-id="element-763">
              We offer flexible scheduling, volume pricing, and dedicated
              account management so your fleet stays maintained without
              disrupting your operations. All 3 of our locations are open 24/7 —
              we work around your schedule, not the other way around.
            </p>
            <a href="tel:3012549001" className="inline-flex items-center gap-2 text-white font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-764">
              <PhoneIcon size={16} data-id="element-765" /> Call (301) 254-9001
            </a>
          </div>
          <div className="overflow-hidden" style={{
          height: '420px'
        }} data-id="element-766">
            <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=800&q=80" alt="Fleet vehicles" className="w-full h-full object-cover" data-id="element-767" />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
      background: '#111111'
    }} data-id="element-768">
        <div className="max-w-7xl mx-auto" data-id="element-769">
          <div className="text-center mb-14" data-id="element-770">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-771">
              What's Included
            </p>
            <h2 className="font-black text-white text-3xl sm:text-4xl" data-id="element-772">
              Fleet Service Benefits
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-773">
            {[{
            icon: TruckIcon,
            title: 'All Vehicle Types',
            body: 'Cars, vans, box trucks, semi-trucks — we service every vehicle in your fleet with the right tires for the job.'
          }, {
            icon: ClockIcon,
            title: '24/7 Availability',
            body: 'All 3 DMV locations are open around the clock. Schedule service at any time that works for your operations.'
          }, {
            icon: ShieldCheckIcon,
            title: 'Certified Technicians',
            body: 'Every technician is trained and certified. Your fleet vehicles are in expert hands every single visit.'
          }, {
            icon: CheckCircle2Icon,
            title: 'Volume Pricing',
            body: 'Significant discounts for fleet accounts. The more vehicles you have, the more you save on every service.'
          }, {
            icon: CheckCircle2Icon,
            title: 'Scheduled Maintenance',
            body: 'We set up recurring service schedules so your tires are always rotated, balanced, and inspected on time.'
          }, {
            icon: CheckCircle2Icon,
            title: 'Dedicated Account Rep',
            body: 'A single point of contact manages your entire fleet account — no confusion, no runaround.'
          }].map(({
            icon: Icon,
            title,
            body
          }) => <div key={title} className="p-8" style={{
            background: '#1a1a1a',
            borderTop: '3px solid #CC0000'
          }} data-id="element-774">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" style={{
              background: 'rgba(204,0,0,0.20)'
            }} data-id="element-775">
                  <Icon size={20} style={{
                color: '#CC0000'
              }} data-id="element-776" />
                </div>
                <h3 className="font-black text-white text-base mb-3" data-id="element-777">
                  {title}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: '#616365'
            }} data-id="element-778">
                  {body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Fleet Quote Form */}
      <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
      background: '#F5F5F5'
    }} data-id="element-779">
        <div className="max-w-2xl mx-auto" data-id="element-780">
          <div className="text-center mb-12" data-id="element-781">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-782">
              Get Started
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl mb-3" data-id="element-783">
              Request a Fleet Quote
            </h2>
            <p className="text-base" style={{
            color: '#616365'
          }} data-id="element-784">
              Fill out the form below and our fleet team will contact you within
              24 hours.
            </p>
          </div>

          {submitted ? <div className="text-center py-16 bg-white p-10" data-id="element-785">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-786">
                <CheckCircleIcon size={32} className="text-green-500" data-id="element-787" />
              </div>
              <h3 className="text-2xl font-black text-black mb-3" data-id="element-788">
                Request Received!
              </h3>
              <p className="text-base max-w-sm mx-auto mb-8" style={{
            color: '#616365'
          }} data-id="element-789">
                Our fleet team will reach out within 24 hours to discuss your
                needs and provide a custom quote.
              </p>
              <Link to="/" className="inline-block text-white font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-790">
                Back to Home
              </Link>
            </div> : <form onSubmit={handleSubmit} className="space-y-4 bg-white p-10" data-id="element-791">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-792">
                <input name="company" value={form.company} onChange={handleChange} placeholder="Company Name *" required className={inputClass} data-id="element-793" />
                <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name *" required className={inputClass} data-id="element-794" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-795">
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className={inputClass} data-id="element-796" />
                <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="Phone Number *" required className={inputClass} data-id="element-797" />
              </div>
              <select name="fleet" value={form.fleet} onChange={handleChange} required className={inputClass} data-id="element-798">
                <option value="" data-id="element-799">Fleet Size *</option>
                <option value="1-5" data-id="element-800">1–5 vehicles</option>
                <option value="6-20" data-id="element-801">6–20 vehicles</option>
                <option value="21-50" data-id="element-802">21–50 vehicles</option>
                <option value="50+" data-id="element-803">50+ vehicles</option>
              </select>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your fleet and service needs..." rows={4} className={inputClass} style={{
            resize: 'none'
          }} data-id="element-804" />
              <button type="submit" className="w-full text-white font-black uppercase tracking-widest py-4 text-sm transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-805">
                Submit Fleet Request
              </button>
            </form>}
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-black py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-806">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-807">
          Ready to Get Your Fleet on a Service Plan?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-808">
          Call us directly or visit any of our 3 DMV locations today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-809">
          <a href="tel:3012549001" className="inline-flex items-center justify-center gap-2 text-white font-bold text-base px-8 py-4 transition-colors duration-200" style={{
          background: '#CC0000'
        }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-810">
            <PhoneIcon size={18} data-id="element-811" /> (301) 254-9001
          </a>
          <Link to="/locations" className="inline-flex items-center justify-center border-2 border-white text-white font-bold text-base px-8 py-4 transition-colors duration-200" onMouseEnter={e => {
          e.currentTarget.style.background = 'white';
          e.currentTarget.style.color = '#000';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = 'white';
        }} data-id="element-812">
            Find a Location
          </Link>
        </div>
      </section>
    </div>;
}